var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 57.9302C37.0752 57.9302 34.7042 60.3012 34.7042 63.226C34.7042 66.1508 37.0752 68.5218 40 68.5218C42.9248 68.5218 45.2958 66.1508 45.2958 63.226C45.2958 60.3012 42.9248 57.9302 40 57.9302Z",
    fill: "#220046"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2958 51.831H34.7042L34.7042 11.3803L45.2958 11.3803L45.2958 51.831Z",
    fill: "#220046"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80ZM40 76.3944C60.1001 76.3944 76.3944 60.1001 76.3944 40C76.3944 19.8999 60.1001 3.60563 40 3.60563C19.8999 3.60563 3.60563 19.8999 3.60563 40C3.60563 60.1001 19.8999 76.3944 40 76.3944Z",
    fill: "#220046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.e7b1694d82dc1c21b17c74f5fdc4f33a.svg";
export { ForwardRef as ReactComponent };